export const RETURNS_TABLE_HEAD_CELLS = [
    { id: 'dueDate', numeric: false, disablePadding: false, label: 'Due Date' },

    { id: 'customerName', numeric: false, disablePadding: false, label: 'Customer Name' },
    { id: 'originalTrackingId', numeric: false, disablePadding: false, label: 'Original Tracking Number' },
    { id: 'orderId', numeric: false, disablePadding: false, label: 'Order ID' },
    { id: 'rmaNum', numeric: false, disablePadding: false, label: 'RMA #' },
    { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
    { id: 'returnedDate', numeric: false, disablePadding: false, label: 'Returned Date' },
    { id: 'assignedToName', numeric: false, disablePadding: false, label: 'Assigned To' }
];

export const DEFAULT_SORT_BY_HEAD_CELL = 'dueDate';

export const CREATE_RETURN_TITLE = 'Create a customer return';
export const BACK_TO_MENU = 'Back to Menu';
export const RETURN_TOOLBAR_TITLE = 'Returns';

export const CONDITIONS = [
    'Good',
    'Damaged',
    'Partially Damaged',
    'Used',
    'Date Written',
    'Wrong Product',
    'Other'
];

export const ACTIONS = [
    'Added Back To Inventory',
    'Discarded',
    'Pending'
];

export const CANCEL = 'Cancel';
export const SAVE = 'Save';
export const COMPLETE_RETURN = 'Complete Return';

export const COMMENTS_TABLE_TITLE = 'Comments';

export const DEFAULT_ROWS_PER_PAGE = 50;
export const ROWS_PER_PAGE_LABEL = 'Returns per page'
export const COMPLETED_STATUS = "Completed";

export const SHOW_MY_RETURNS = "Show my returns only"
export const SHOW_COMPLETED_RETURNS = "Show completed returns"
export const SHOW_REFUND_PENDING_RETURNS = "Show refund pending"

export const REFUND_AMOUNT_CHECKBOX = "Refund Amount";
export const LOCATION_TEXTFIELD_LABEL = "Location";

export const ERROR_MESSAGE = "Required field";

export const PENDING = "Pending";


export const RETURN_SETTINGS_TOOLBAR_TITLE = "Return Settings";

export const RETURN_LABEL_COST_INFO = "Return label cost if one was provided to the customer"
export const PRICE_INFO = "Purchase price of the product. Tax is automatically taken into account"
export const SHIPPING_COST_INFO = "Original shipping cost incurred"
export const OTHER_COSTS_INFO_PART1 = "Additional cost as a percentage or fix dollar amount"
export const DIFFERENCE_REDIRECT_LABEL_INFO = "The difference between the shipping cost that we would incur if we ship the product directly to the new customer and the shipping cost from the original customer to the new customer. If this difference is less than or equal to 0, no amount will be deducted from or credited to the original customer"
export const REFUND_TYPES = ['Full Refund', 'Deduct Restocking Fee Only', 'Deduct Restocking Fee And Return Cost']
export const REFUND_DETAIL_MAP = {
    'salePrice' : 'Sale Price',
    'missingFilterAmount' : 'Missing/Damage Filter',
    'originalShippingCost' : 'Restocking Fees',
    'returnShippingCost' : 'Return Label Fee',
    'otherCost' : 'Other Charges'
}
export const REFUND_DETAIL_TAX_MAP = {
    'saleTax' : 'Sales Tax',
    'missingFilterTax' : 'Missing/Damage Filter Tax',
    'originalShippingCostTax' : 'Restocking Fees Tax',
    'returnShippingCostTax': 'Return Label Fee Tax',
    'otherCostCostTax' : 'Other Charges Tax'
}
